<template>
  <div>
    <!-- 電腦版 - table 表頭（只渲染一次） -->
    <template v-if="!$vuetify.breakpoint.sm && !$vuetify.breakpoint.xs">
      <v-divider class="ma-0 mt-2" />
      <v-row class="pa-4 font-weight-bold" no-gutters>
        <v-col cols="10">
          <v-row no-gutters>
            <v-col cols="4" class="is-word-break">{{
              $t("activity_session_name")
            }}</v-col>
            <v-col cols="2">{{ $t("activity_session_date") }}</v-col>
            <v-col cols="2">{{ $t("activity_session_time") }}</v-col>
            <v-col cols="4" class="is-word-break">{{
              $t("activity_session_location")
            }}</v-col>
          </v-row>
        </v-col>
        <v-col cols="2">{{
          $t(`activity_session_status${campaign.isLottery ? "_lottery" : ""}`)
        }}</v-col>
      </v-row>
      <v-divider class="ma-0" />
    </template>
    <!-- 場次列表 -->
    <div v-for="(session, i) in sessions" :key="i" class="sesstion-item">
      <v-row class="pa-4 flex-column flex-sm-row" no-gutters>
        <v-col
          cols="12"
          sm="10"
          md="10"
          :class="{
            'text-small': $vuetify.breakpoint.xs || $vuetify.breakpoint.sm,
          }"
        >
          <v-row class="mx-0 flex-column flex-md-row" no-gutters>
            <v-col
              cols="12"
              sm="12"
              md="4"
              class="d-flex text-left font-weight-bold text-regular py-2 is-word-break"
              :align="
                $vuetify.breakpoint.xs || $vuetify.breakpoint.sm
                  ? 'left'
                  : 'center'
              "
            >
              {{ session.name }}
            </v-col>
            <v-col
              cols="12"
              sm="12"
              md="2"
              class="px-md-2 d-flex justify-md-center align-left align-md-center"
            >
              <div class="d-flex mb-2 mb-md-0">
                <div
                  class="grey--text text--darken-1 d-block d-md-none mr-2 wordBreakKeepAll"
                >
                  {{ $t("activity_mobile_session_date") }}
                </div>
                <div v-html="dateDisplay(session.date)"></div>
              </div>
            </v-col>
            <v-col
              cols="12"
              sm="12"
              md="2"
              class="px-md-2 d-flex justify-md-center align-md-center"
            >
              <div class="d-flex mb-2 mb-md-0">
                <div
                  class="grey--text text--darken-1 d-block d-md-none mr-2 wordBreakKeepAll"
                >
                  {{ $t("activity_mobile_session_time") }}
                </div>
                <div>{{ timeDisplay(session.time) }}</div>
              </div>
            </v-col>
            <v-col
              cols="12"
              sm="12"
              md="4"
              class="px-md-2 d-flex justify-md-center align-md-center is-word-break"
            >
              <div class="d-flex mb-2 mb-md-0">
                <div
                  class="grey--text text--darken-1 d-block d-md-none mr-2 wordBreakKeepAll"
                >
                  {{ $t("activity_mobile_session_location") }}
                </div>
                <div class="text-left text-md-center location-content">
                  {{ session.location }}
                  <div
                    v-if="session.address"
                    class="grey--text text--darken-3 text-small d-inline d-md-block"
                  >
                    {{ session.address }}
                  </div>
                </div>
              </div>
            </v-col>
          </v-row>
        </v-col>
        <v-col
          cols="12"
          sm="2"
          md="2"
          align-self="center"
          class="font-weight-bold"
        >
          <v-divider class="d-block d-sm-none mb-5 mt-3" />
          <SessionTable
            :eventId="eventId"
            :session="session"
            @emitGetSessionStatus="$emit('emitGetSessionStatus')"
          />
        </v-col>
      </v-row>
      <div
        v-if="i + 1 !== sessions.length"
        class="red-dash-divider d-none d-sm-block"
      />
    </div>
  </div>
</template>

<script>
import SessionTable from "@/views/components/SessionTable";
import dayjs from "dayjs";
import { mapGetters } from "vuex";

export default {
  name: "SessionListItem",
  components: { SessionTable },
  props: {
    sessions: {
      type: Array,
      required: true,
    },
    eventId: {
      type: String,
      default: "",
    },
  },
  computed: {
    ...mapGetters({
      campaign: "event/campaign",
    }),
  },
  methods: {
    timeDisplay(timeString) {
      const ts =
        timeString.indexOf(" ~ ") > -1 ? timeString.split(" ~ ") : timeString;
      if (Array.isArray(ts) && ts[0] !== ts[1]) {
        return timeString;
      } else {
        return Array.isArray(ts) ? ts[0] : timeString;
      }
    },
    dateDisplay(dateString) {
      if (!dateString) return "";
      const days = [
        this.$t("activity_sunday"),
        this.$t("activity_monday"),
        this.$t("activity_tuesday"),
        this.$t("activity_wensday"),
        this.$t("activity_thursday"),
        this.$t("activity_friday"),
        this.$t("activity_saturday"),
      ];

      const ds =
        dateString.indexOf(" ~ ") > -1 ? dateString.split(" ~ ") : dateString;
      if (Array.isArray(ds) && ds[0] !== ds[1]) {
        return !this.$vuetify.breakpoint.xs && !this.$vuetify.breakpoint.sm
          ? `<div>${ds[0]}(${days[dayjs(ds[0]).day()]})</div> ~ <div>${ds[1]}(${
              days[dayjs(ds[1]).day()]
            })</div>`
          : `${ds[0]}(${days[dayjs(ds[0]).day()]}) ~ ${ds[1]}(${
              days[dayjs(ds[1]).day()]
            })`;
      } else {
        const str = Array.isArray(ds) ? ds[0] : dateString;
        return `${str}(${days[dayjs(str).day()]})`;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.wordBreakKeepAll {
  word-break: keep-all;
}

@media screen and (max-width: 600px) {
  .sesstion-item {
    border: solid 2px $grey-lighten-1;
    border-radius: $radiusMobile;
    padding-left: 12px;
    padding-right: 12px;
    margin-bottom: 16px;
  }

  .location-content {
    max-height: 42px;
    overflow: hidden;
  }
}
</style>
